import CloseIcon from '@mui/icons-material/Close'
import { Box, IconButton, Typography, useMediaQuery } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import { useState } from 'react'

export default function SmallScreenWarning() {
  const [isOpen, setIsOpen] = useState(true)
  const theme = useTheme()
  const isSmallScreen = useMediaQuery(theme.breakpoints.down('sm'))

  if (!isSmallScreen || !isOpen) {
    return null
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        alignItems: 'center',
        gap: 1,
        border: '1px solid',
        borderColor: 'secondary.dark',
        padding: 2,
        borderRadius: 2,
        position: 'absolute',
        top: 8,
        left: 8,
        right: 8,
        zIndex: 10,
        backdropFilter: 'blur(2px)',
        background: 'rgba(255, 255, 255, 0.9)',
      }}
    >
      <IconButton
        size='small'
        onClick={() => setIsOpen(false)}
        sx={{
          position: 'absolute',
          top: 4,
          right: 4,
        }}
      >
        <CloseIcon fontSize='small' />
      </IconButton>
      <Box sx={{ display: 'flex', flexDirection: 'column' }}>
        <Typography
          variant='h4'
          color='secondary.dark'
          fontWeight={700}
          sx={{ textAlign: 'center' }}
        >
          WARNING: LIMITED FUNCTIONALITY
        </Typography>
        <Typography variant='body2' sx={{ textAlign: 'center' }}>
          Please use a desktop browser for the best experience.
        </Typography>
      </Box>
    </Box>
  )
}
